import { render, staticRenderFns } from "./essentialInfo.vue?vue&type=template&id=2d0c1810&scoped=true&"
import script from "./essentialInfo.vue?vue&type=script&lang=js&"
export * from "./essentialInfo.vue?vue&type=script&lang=js&"
import style0 from "./essentialInfo.vue?vue&type=style&index=0&id=2d0c1810&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c1810",
  null
  
)

export default component.exports